import React from "react";
import { Player } from "../../apis/types";
import { Colors } from "../../utils/colors";
import { IncludePlayerForPayment } from "../includePlayerForPayment/IncludePlayerForPayment";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { PlayerToPayDetailOld } from "../playerToPayDetail/PlayerToPayDetailOld";

type props = {
  player: Player;
  index: number;
};

export const PlayerToPayOld: React.FC<props> = ({ player, index }) => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
        <PlayerToPayDetailOld player={player} />
        <IncludePlayerForPayment player={player} />
      </div>
      {index <
        selectCircleStore.adjustAndGetSelectedPlayersList().length - 1 && (
        <div
          style={{
            width: "100%",
            border: `1px solid ${Colors.lightGreyBackground}`,
            marginTop: 20,
            marginBottom: 20,
          }}
        />
      )}
    </div>
  );
};
